'use strict';

angular.module('shiftTraderApp')
    .directive('saPrintWorkPeriodItem', ['$timeout', '$compile','TimeService', '$filter',
    function ($timeout, $compile, TimeService, $filter) {
      var genTemplate = function(isTraining) {
        var html = '';
        html += '<div>';
        html += '<span>{wpStartTime}</span>-<span>{wpEndTime}</span><span> (</span>';
        if (isTraining) {
          html += '<span>TR-</span>';
        }
        html += '<span>{abbreviatedPositionName}</span><span>)</span>';
        return html;
      };

    var fillTemplate = function(wp) {
      var tpl = genTemplate(wp.training);
      tpl = tpl.replace('{wpStartTime}', TimeService.minimalMomentFormat(wp.start_time, true));
      tpl = tpl.replace('{wpEndTime}', TimeService.minimalMomentFormat(wp.end_time, true));
      tpl = tpl.replace('{abbreviatedPositionName}', $filter('abbreviatedPosition')(wp.position.name, 8));
      return tpl;
    };


      return {
        restrict: 'A',
        link: function (scope, element) {
          var initializing = true;
          scope.element = $(element);

          scope.element.html($compile(fillTemplate(scope.workPeriod))(scope));

          var setModified = function(expr) {
            scope.$watch(expr, function() {
              if (initializing) {
                $timeout(function() {initializing = false;});
              } else {
                scope.element.addClass('modified');
                $timeout(function() {
                  scope.element.removeClass('modified');
                }, 5000);
              }
            });
          };
          angular.forEach(['workPeriod._startTimeUnix', 'workPeriod._endTimeUnix'], setModified);

          var setUnpublishedClass = function() {
            if (_.isNull(scope.workPeriod.published_by_id)) {
              scope.element.addClass('unpublished');
            } else {
              scope.element.removeClass('unpublished');
            }
          };

          scope.$watch('workPeriod.published_by_id', function(newVal, oldVal) {
            if (newVal !== oldVal && !_.isUndefined(scope.workPeriod)) {
              setUnpublishedClass();
            }
          });


          setUnpublishedClass();
        }
      };
    }]);
